export default ($api) => ({
  loaiQuyHoach: (data) => {
    return $api.get('loai-quy-hoaches', { params: data })
  },
  thongTinQuyHoach: (data) => {
    return $api.get('bai-viets', { params: data })
  },
})
